export default {"src":"/_next/static/media/27-icon.89a15ee9.svg","height":46,"width":28,"blurWidth":0,"blurHeight":0};